import { z } from 'zod';
/**
 * InquiryStage — named stages of the study inquiry pipeline.
 *
 * v2 (deterministic-first): anchoring → filtering → reasoning →
 * validating → refining → enriching. Old stages kept for backward
 * compat with persisted messages.
 */
export const InquiryStageSchema = z.enum([
    // v2 pipeline stages
    'anchoring',
    'filtering',
    'reasoning',
    'guarding',
    'validating',
    'refining',
    'enriching',
    // v1 stages (backward compat for persisted messages)
    'discerning',
    'analyzing',
    'searching',
    'extracting',
    'verifying',
]);
export const INQUIRY_STAGES = {
    // v2 pipeline
    anchoring: { label: 'Finding the verse anchor', order: 1 },
    filtering: { label: 'Checking the inquiry', order: 2 },
    reasoning: { label: 'Reasoning through Scripture', order: 3 },
    // V6.1 Non-Negotiable Guards — doctrinal floor check + regenerate.
    guarding: { label: 'Checking doctrinal guards', order: 4 },
    validating: { label: 'Validating the response', order: 5 },
    refining: { label: 'Refining exposition', order: 6 },
    enriching: { label: 'Enriching with study tools', order: 7 },
    // v1 backward compat
    discerning: { label: 'Discerning intent', order: 1 },
    analyzing: { label: 'Analyzing references', order: 2 },
    searching: { label: 'Searching the scriptures', order: 3 },
    extracting: { label: 'Extracting key words', order: 6 },
    verifying: { label: 'Verifying response', order: 7 },
};
/** Look up the display label for a stage key. */
export function getStageLabel(stage) {
    return INQUIRY_STAGES[stage]?.label ?? stage;
}
//# sourceMappingURL=inquiry-stage.js.map